module.exports = __webpack_public_path__ + "img/icon_grab@2x.e0cc9486.png";